import React from 'react';
import Header from './components/Header';
import Refund from './components/Refund';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import { useParams } from 'react-router-dom';

type PolicyType = 'refund' | 'privacy' | 'terms';

const titleMap: Record<PolicyType, string> = {
  refund: '수강 취소·환불 및 제재조치 규정',
  privacy: '라이브클래스 개인정보처리방침',
  terms: '라이브클래스 서비스 이용약관'
};

const policyMap: Record<PolicyType, React.ReactNode> = {
  refund: <Refund />,
  privacy: <Privacy />,
  terms: <Terms />
};

const PolicyPage: React.FC = () => {
  // URL에서 type 가져오기
  const { type } = useParams<{ type: PolicyType }>();

  if (!type || !policyMap[type]) {
    return <div>잘못된 정책 페이지</div>;
  }

  return (
    <div className="min-h-screen bg-blue-50/40">
      <Header title={titleMap[type]} />
      <div className="container max-w-7xl mx-auto px-4">{policyMap[type]}</div>
    </div>
  );
};

export default PolicyPage;
